import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, Redirect, useHistory } from 'react-router-dom'
import config from '../../config'
import { loginUser } from '../../ducks/auth'
import routes from '../../routes'
import { ForgetPassword } from './ForgetPassword'
import { Button, Form } from 'react-bootstrap'
import styled from 'styled-components'
import { desktopAssets, fixedAssets, mobileAssets } from 'src/containers/PreCache'
import Media from 'react-media'
import { SIZES } from 'src/styles/theme'
import Amplitude from 'src/utils/amplitudeHelper'
import Layout from '../register/Layout'
import { LoginForm } from './LoginForm'

export const LoginPage = () => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [agree, setAgree] = useState(0)

  const { isFetching, isAuthenticated } = useSelector((state) => state.auth)
  const history = useHistory()
  const dispatch = useDispatch()

  const handleLogin = (e) => {
    e.preventDefault()
    loginUser(dispatch, history, {
      email,
      password,
    })
  }
  const onPasswordInput = (e) => {
    setPassword(e.target.value.toUpperCase())
  }

  const onEmailInput = (e) => {
    setEmail(e.target.value.toLowerCase())
  }

  const onAgreeInput = (e) => {
    setAgree(e.target.checked)
  }

  useEffect(() => {
    document.title = `${config.eventName} | Login`
  }, [])

  const showHelpDesk = () => {
    const cpt = window.chaport
    cpt.open()
    Amplitude.clickHelpDesk()
  }

  if (isAuthenticated) {
    return <Redirect to={routes.lobby} />
  } else {
    return (
      <Layout>
        <Media query={`(max-width: ${SIZES.mobileBreakpoint})`}>
          {(matches) =>
            matches ? (
              <MobilePage>
                <div>
                  <Link to="/">
                    <img src={mobileAssets.landingBgMobile} alt="Background" style={{ width: '100%', height: 'auto' }} />
                  </Link>
                </div>
                <div className="content-wrapper">
                  <div className="content">
                    <div className="login-wrapper">
                      <h2>Log in My Profile</h2>
                      <LoginForm
                        handleLogin={handleLogin}
                        onEmailInput={onEmailInput}
                        onPasswordInput={onPasswordInput}
                        onAgreeInput={onAgreeInput}
                        email={email}
                        password={password}
                        isFetching={isFetching}
                      />
                    </div>
                  </div>
                </div>
              </MobilePage>
            ) : (
              <LoginPageWrapper>
                <div className="wrap">
                  <div className="p-4">
                    <Link to="/">
                      <img src={desktopAssets.headerLogo} alt="Background" className="header-logo" />
                    </Link>
                  </div>
                  <div className="content-wrapper">
                    <h2
                      style={{
                        marginBottom: '40px',
                      }}
                    >
                      Log in My Profile
                    </h2>
                    <LoginForm
                      handleLogin={handleLogin}
                      onEmailInput={onEmailInput}
                      onPasswordInput={onPasswordInput}
                      onAgreeInput={onAgreeInput}
                      email={email}
                      password={password}
                      isFetching={isFetching}
                    />
                  </div>
                </div>
              </LoginPageWrapper>
            )
          }
        </Media>
      </Layout>
    )
  }
}
const MobilePage = styled.div`
  h2 {
    color: #434343;
    text-align: center;
    font-size: 26px;
    font-weight: 700;
    line-height: 30px;
    margin-bottom: 40px;
  }
`

const LoginPageWrapper = styled.div`
  .content-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: 863px;
    width: 100%;
  }

  form {
    max-width: 400px;
    width: 100%;
  }

  .helper {
    background: #f8f8f8;
    padding: 24px 26px;
  }

  @media and screen (min-width: ${SIZES.mobileBreakpoint}) {
    margin: 0 auto;
  }
`
